export default Object.freeze({
  debug: false,
  swapSpeed: 500,
  ignore_debug: {
    gem: true,
    game: false
  }
});



// WEBPACK FOOTER //
// ./js/options.js